import {
  MemberProfileLocationTableFilters,
  MemberProfileLocationTableRow
} from '@bo-components/members/memberProfile';
import { Table, TableBody, TableHeader } from '@library/components/table';
import {
  getCombinedMapCoordsList,
  getMemberLocationTableHeaders
} from '@bo-utils/members/memberProfileMap';
import { useContext, useMemo } from 'react';
import { Loading } from '@library/components/Loading';
import { MemberProfileMapContext } from '@bo-hooks/members/useMemberProfileMapContext';
import { NoResults } from '@library/components/NoResults';
import { map } from 'ramda';

export const MemberProfileLocationTable = () => {
  const {
    data: mapData,
    entriesChecked,
    isLoading,
    showMapTable
  } = useContext(MemberProfileMapContext);

  const tableHeader = useMemo(
    () => getMemberLocationTableHeaders(entriesChecked),
    [entriesChecked]
  );

  const tableBodyContent = useMemo(() => {
    if (isLoading) {
      return <Loading loadingMessage="Loading coordinates" />;
    }

    if (!mapData?.length) {
      return (
        <NoResults
          className="m-0 w-full"
          dataTestId="no-member-map-coordinates"
          label="There are no coordinates for this date"
          title="No Coordinates"
        />
      );
    }

    const tableData = getCombinedMapCoordsList(mapData);

    return map(
      (data) => <MemberProfileLocationTableRow key={data.id} data={data} />,
      tableData
    );
  }, [isLoading, mapData]);

  return (
    <div className="border-soFresh-130 flex flex-col gap-4 rounded-lg border">
      <MemberProfileLocationTableFilters />
      {showMapTable && (
        <Table className="border-soFresh-140 m-4 mt-0 overflow-x-auto rounded-lg border">
          <TableHeader
            className="bg-soFresh-120 min-w-[1020px]"
            headers={tableHeader}
          />
          <TableBody className="max-h-96 min-w-[1020px] overflow-y-auto">
            {tableBodyContent}
          </TableBody>
        </Table>
      )}
    </div>
  );
};
